import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, mergeMap, timeout } from 'rxjs/operators';
import { AppNotification, NotificationsMarkAsSeenDto } from 'src/app/shared';
import {
  ConfigService,
  HTTP_REQUESTS_TIMEOUT,
  UserService,
} from 'src/app/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  public status$!: BehaviorSubject<AppNotification[]>;

  constructor(
    private configService: ConfigService,
    private userService: UserService,
    private http: HttpClient
  ) {
    const statusInit: AppNotification[] = [];
    this.status$ = new BehaviorSubject(statusInit);
  }

  public notificationsSubject$(): Observable<AppNotification[]> {
    return this.userService.notificationsSubject$;
  }

  public getNotifications$(): Observable<AppNotification[]> {
    return this.userService.getUserNotifications().pipe(
      map((value) => {
        this.status$.next(value);
        return value;
      })
    );
  }

  /**
   * @param notifications
   */
  markAsSeen(dto: NotificationsMarkAsSeenDto) {
    const url = this.getUrl('notificationsMarkAsSeen');
    return this.http.post(url, dto, { withCredentials: true }).pipe(
      timeout(HTTP_REQUESTS_TIMEOUT),
      mergeMap(() => this.getNotifications$())
    );
  }

  getUrl(pointer: string): string {
    return this.configService.getUrl(`user.${pointer}`);
  }
}
